<template>
  <div class="mt-4 d-flex flex-wrap">
    <v-col cols="12">
        <v-btn v-for="name in pdfNames"
          :key="name"
          large
          color="primary"
          @click="goToPage(name)"
          class="my-3 mx-3"
          style="width:320px"
        >
          <span>{{name}}</span>
          <v-spacer />
          <v-icon class="mr">mdi-file-pdf-outline</v-icon>
        </v-btn>
     </v-col>
  </div>
</template>
<script>
export default {
  data() {
     return {
       pdfNames: ['Installation Instructions', 'Release Notes', 'Configuring Backup System']
    };
  },
  methods: {
    goToPage(pdfName) {
      this.$router.push({ name: 'Document',  params: {docName: pdfName}});
    }
  }
}
</script>